import Vue from 'vue';
import firebase from 'firebase';
import 'bootstrap';
import App from './App.vue';
import router from './router';
import likesFilter from './filters/likes';
import './bus';

// Vue.use(VueAxios, axios, clipboard, vClipboard);
Vue.config.productionTip = false;
Vue.filter('likes', likesFilter);

// Initialize Firebase
const config = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTODOMAIN,
  databaseURL: process.env.VUE_APP_DATAURL,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MSGID,
};
firebase.initializeApp(config);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');

// 驗證
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    firebase.auth().onAuthStateChanged((userState) => {
      if (userState) {
        // 如果已經登入就繼續
        next();
      } else {
        // 如果還沒登入就轉到登入頁
        next({
          path: '/',
        });
      }
    });
  } else {
    next();
  }
});
